import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loginRequired, setLoginRequired] = useState(false);

  useEffect(() => {
    // Check stored JWT
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('userData');
    if (token && userData) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.exp * 1000 > Date.now()) {
          setUser(JSON.parse(userData));
        } else {
          localStorage.removeItem('token');
          localStorage.removeItem('userData');
        }
      } catch {
        localStorage.removeItem('token');
        localStorage.removeItem('userData');
      }
    }

    // Fetch requireLogin parameter (always public, no auth needed)
    api.get('/parametros/requireLogin')
      .then(res => {
        setLoginRequired(res.data?.ParametroValor === '1');
      })
      .catch(() => {
        setLoginRequired(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('userData', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userData');
    setUser(null);
  };

  const refreshLoginRequired = () => {
    api.get('/parametros/requireLogin')
      .then(res => setLoginRequired(res.data?.ParametroValor === '1'))
      .catch(() => setLoginRequired(false));
  };

  const canEdit = user?.rol === 'superadmin' || user?.rol === 'editor';
  const isSuperAdmin = user?.rol === 'superadmin';
  const isReader = user?.rol === 'reader';

  return (
    <AuthContext.Provider value={{ user, login, logout, canEdit, isSuperAdmin, isReader, loading, loginRequired, refreshLoginRequired }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
